import { createContext, useContext, useState, useCallback } from 'react'
import { T } from '@/lib/theme'

const ToastCtx = createContext({ push: () => {} })

export function useToast() { return useContext(ToastCtx) }

let idSeed = 1

export function ToastProvider({ children }) {
  const [toasts, setToasts] = useState([])

  const push = useCallback((message, kind = 'info', ttl = 4000) => {
    const id = idSeed++
    setToasts((t) => [...t, { id, message, kind }])
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), ttl)
  }, [])

  return (
    <ToastCtx.Provider value={{ push }}>
      {children}
      <div style={{
        position: 'fixed', top: 12, right: 12, zIndex: 9999,
        display: 'flex', flexDirection: 'column', gap: 8, maxWidth: 380,
      }}>
        {toasts.map((t) => (
          <div key={t.id} style={{
            padding: '10px 14px',
            borderRadius: 8,
            fontSize: 13,
            color: T.text,
            fontFamily: T.fontM,
            background: T.surface,
            border: `1px solid ${kindBorder(t.kind)}`,
            boxShadow: T.shadowMed,
          }}>
            <span style={{ color: kindText(t.kind), fontWeight: 600, marginRight: 6 }}>
              {kindLabel(t.kind)}
            </span>
            {t.message}
          </div>
        ))}
      </div>
    </ToastCtx.Provider>
  )
}

function kindBorder(k) {
  if (k === 'error')   return 'rgba(248,113,113,0.5)'
  if (k === 'success') return 'rgba(45,230,75,0.5)'
  return T.border
}
function kindText(k) {
  if (k === 'error')   return T.negative
  if (k === 'success') return T.positive
  return T.accent
}
function kindLabel(k) {
  if (k === 'error')   return 'Error'
  if (k === 'success') return 'Done'
  return 'Info'
}
